<template>
  <div class="impact-embed-links">
    <div :style="'background-color:'+ widget.bgColor +'; vertical-align: middle;flex-direction: column;padding:2px 0px; display: flex; min-height: 100vh; justify-content: center;'">
      <div style=" display: flex; flex-direction:column;">
        <div :style="'font-family:'+ widget.font +';'">
          <div :style="'text-align: center; font-size: '+ widget.font_size +'px;color: #000;'" v-html="widget.msg">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import widgetAPI from '../../api/widget'
export default {
  data () {
    return {
      widget: {
        bgColor: '#f1f1f1',
        color: '#000',
        font: 'Avenir',
        font_size: 12,
        impact: 0,
        msg: "Oops! Looks like your widget has been not upgraded. <br> Please <a href='https://account.b1g1.com/giving-widget' target='_blank'>click here</a> to upgrade your widget"
      }
    }
  },
  methods: {
    commafy (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    loadWidgetSettings () {
      return widgetAPI.getWidgetUserLog(this.$route.params.id).then((response) => {
        console.log(response)
        this.isWidgetUserDowngrade = response.isWidgetUserDowngrade
        this.widget.bgColor = response.background_color ? response.background_color : '#f1f1f1'
        this.widget.color = response.text_color ? response.text_color : '#000'
        this.widget.font = response.font ? response.font : 'Avenir'
        this.widget.font_size = response.font_size ? response.font_size : '12'
        this.widget.impact = response.beneficiaries ? response.beneficiaries : 0
        this.widget.msg = response.msg ? response.msg : "Oops! Looks like your widget has been not upgraded. <br> Please <a href='https://account.b1g1.com/giving-widget' target='_blank'>click here</a> to upgrade your widget"
      })
    }
  },
  created () {
    let widgetSettingsPromise = this.loadWidgetSettings()

    Promise.all([widgetSettingsPromise]).then(() => {
      setTimeout(function () {
        document.documentElement.style.overflow = 'hidden'
      }, 1000)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/TestWidget.vue